import { usePostDetailsParam } from '@anytag/shared-hooks';

export const useEngagementProposalInfluencerDetailsParam = () => {
  const paramKey = 'influencerPopupId';

  const { urlPostId, setPostDetailsParam: setInfluencerDetailsParam } = usePostDetailsParam(paramKey);

  return { paramKey, influencerPopupId: urlPostId ? +urlPostId : undefined, setInfluencerDetailsParam };
};
